<template>
  <div>
    <!-- ================= seleção de painel ================= -->
    <el-row :gutter="10" class="u-mb-10">
      <el-col :xs="24" :sm="10">
        <el-select v-model="slug" placeholder="Selecione o painel" style="width:100%"
                   @change="trocarPainel" data-test="seletor-painel">
          <el-option v-for="p in paineis" :key="p.slug" :label="p.nome" :value="p.slug"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="6">
        <el-date-picker v-model="dataReferencia" type="date" value-format="yyyy-MM-dd"
                        placeholder="Data de referência" style="width:100%"
                        @change="carregar"></el-date-picker>
      </el-col>
      <el-col :xs="24" :sm="8" style="text-align:right">
        <el-button size="small" icon="el-icon-download" :disabled="!temDados || exportando"
                   @click="dialogExport = true" data-test="btn-exportar">EXPORTAR</el-button>
        <el-button class="u-ml-10" size="small" icon="el-icon-share" :disabled="!temDados || compartilhando"
                   @click="dialogCompartilhar = true" data-test="btn-compartilhar">COMPARTILHAR</el-button>
      </el-col>
    </el-row>

    <!-- ================= filtros ativos (BI 12) ================= -->
    <div v-if="temFiltros" class="u-mb-10" data-test="filtros-ativos">
      <span class="rotulo-filtro">Filtros:</span>
      <el-tag v-for="(valor, dim) in estado.filtros" :key="dim" closable size="small"
              class="u-mr-5" @close="removerFiltro(dim)">
        {{ dim }}: {{ valor }}
      </el-tag>
      <el-button type="text" size="mini" @click="limparTudo" data-test="btn-limpar">limpar tudo</el-button>
    </div>

    <!-- trilha do drill-down -->
    <el-breadcrumb v-if="trilha.length" separator="/" class="u-mb-10" data-test="trilha">
      <el-breadcrumb-item><a @click.prevent="limparTudo" href="#">Todos</a></el-breadcrumb-item>
      <el-breadcrumb-item v-for="(p, i) in trilha" :key="i">{{ p.dimensao }}: {{ p.valor }}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="trilha.length">
        <el-button type="text" size="mini" @click="subir" data-test="btn-subir">subir um nível</el-button>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <!-- ================= três estados distintos ================= -->
    <div v-if="carregando" class="estado" data-test="estado-carregando">
      <i class="el-icon-loading"></i> Carregando…
    </div>

    <el-alert v-else-if="erro" type="error" :closable="false" show-icon
              class="u-mb-10" data-test="estado-erro"
              title="Não foi possível carregar o painel" :description="erro"></el-alert>

    <el-alert v-else-if="vazio" type="info" :closable="false" show-icon
              class="u-mb-10" data-test="estado-vazio"
              title="Sem dados para os critérios selecionados"
              :description="aviso || 'O painel carregou normalmente, mas não há registros. Verifique os filtros ou execute a carga do repositório.'"></el-alert>

    <!-- ================= conteúdo ================= -->
    <template v-else>
      <el-row :gutter="10" class="u-mb-10">
        <el-col :xs="24" :sm="6">
          <div class="cartao" data-test="cartao-total">
            <div class="cartao-rotulo">Total</div>
            <div class="cartao-valor">{{ total }}</div>
            <div class="cartao-nota">Referência: {{ dataExibida }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="18">
          <div class="grafico-wrap">
            <bar-chart v-if="dadosGrafico" :chart-data="dadosGrafico" :options="opcoesGrafico"
                       :height="180" ref="grafico"></bar-chart>
          </div>
        </el-col>
      </el-row>

      <!-- tabela: é por ela que o drill-down e o filtro cruzado acontecem -->
      <table class="table table-striped" data-test="tabela-series">
        <thead>
          <tr><th>{{ rotuloDimensao }}</th><th style="width:120px">Valor</th><th style="width:170px"></th></tr>
        </thead>
        <tbody>
          <tr v-for="(l, i) in series" :key="i" :class="{ 'linha-selecionada': selecionada(l) }">
            <td>{{ l.rotulo }}</td>
            <td>{{ l.valor }}</td>
            <td>
              <el-button type="text" size="mini" @click="filtrarPor(l)" data-test="btn-filtrar">
                {{ selecionada(l) ? 'remover filtro' : 'filtrar' }}
              </el-button>
              <el-button class="u-ml-10" v-if="podeDescer" type="text" size="mini" @click="descerPor(l)"
                         data-test="btn-descer">detalhar</el-button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- ============ recortes: BI 4, 5, 6, 8 ============ -->
      <el-row :gutter="10" class="u-mt-15" v-if="dimensoesDoPainel.length">
        <el-col :xs="24" :sm="12" v-for="dim in dimensoesDoPainel" :key="dim">
          <c-panel :title="tituloRecorte(dim)" titleIcon="fas fa-chart-bar">
            <div v-if="recortes[dim] && recortes[dim].carregando" class="estado-pequeno">
              <i class="el-icon-loading"></i> carregando…
            </div>
            <div v-else-if="recortes[dim] && recortes[dim].erro" class="estado-pequeno erro">
              {{ recortes[dim].erro }}
            </div>
            <div v-else-if="!recortes[dim] || !recortes[dim].itens.length" class="estado-pequeno">
              sem dados para este recorte
            </div>
            <table v-else class="table table-sm">
              <tr v-for="(it, j) in recortes[dim].itens" :key="j">
                <td>{{ it.rotulo }}</td>
                <td style="width:90px">{{ it.valor }}</td>
                <td style="width:80px">
                  <el-button type="text" size="mini" @click="filtrarPorRecorte(dim, it)">filtrar</el-button>
                </td>
              </tr>
            </table>
          </c-panel>
        </el-col>
      </el-row>
    </template>

    <!-- ================= exportação (BI 13) ================= -->
    <el-dialog title="Exportar painel" :visible.sync="dialogExport" width="420px" append-to-body>
      <p class="obs">
        O arquivo leva <b>exatamente os filtros e a data de referência</b> que estão sendo
        exibidos agora.
      </p>
      <div class="resumo-export">
        <div><b>Painel:</b> {{ nomePainel }}</div>
        <div><b>Referência:</b> {{ dataExibida }}</div>
        <div><b>Filtros:</b> {{ temFiltros ? resumoFiltros : 'nenhum' }}</div>
      </div>
      <span slot="footer">
        <el-button @click="dialogExport = false">CANCELAR</el-button>
        <el-button class="u-ml-10" type="primary" :loading="exportando" @click="exportar('pdf')" data-test="export-pdf">PDF</el-button>
        <el-button class="u-ml-10" type="primary" :loading="exportando" @click="exportar('png')" data-test="export-png">IMAGEM</el-button>
        <el-button class="u-ml-10" type="primary" :loading="exportando" @click="exportar('xlsx')" data-test="export-xlsx">EXCEL</el-button>
      </span>
    </el-dialog>

    <!-- ================= compartilhamento (BI 11/17) ================= -->
    <el-dialog title="Compartilhar painel" :visible.sync="dialogCompartilhar" width="520px" append-to-body>
      <p class="obs">
        O link enxerga <b>o mesmo escopo institucional que você enxerga</b>, congelado agora, e
        expira no prazo escolhido.
      </p>
      <el-form label-position="top">
        <el-form-item label="Validade (horas)">
          <el-input-number v-model="horasLink" :min="1" :max="720"></el-input-number>
        </el-form-item>
      </el-form>
      <el-alert v-if="linkGerado" type="success" :closable="false" show-icon class="u-mt-10">
        <div slot="title">Link gerado — expira em {{ linkGerado.expira_em }}</div>
        <el-input :value="linkGerado.url" readonly size="small" class="u-mt-5"></el-input>
      </el-alert>
      <span slot="footer">
        <el-button @click="dialogCompartilhar = false">FECHAR</el-button>
        <el-button class="u-ml-10" type="primary" :loading="compartilhando" @click="compartilhar"
                   data-test="btn-gerar-link">GERAR LINK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 * FASE 5 / BLOCO BA-4 — BI 2, 4, 5, 6, 7, 8, 12, 13 e 17.
 *
 * Os sete dashboards do edital, com filtro cruzado, drill-down e exportação.
 *
 * REGRAS QUE ESTE COMPONENTE OBEDECE — e que a auditoria de frontend do BA-4 verifica:
 *
 * 1. Zero regra de negócio aqui. Agregação, autorização e escopo institucional vêm do
 *    backend. O componente pede e desenha.
 * 2. O estado de interação é do `biInteracao.js` (BA-2), já coberto por 30 testes. Não há
 *    uma segunda implementação de filtro/drill-down dentro do Vue.
 * 3. Três estados DISTINTOS: carregando, erro e vazio. "Sem dados" nunca pode parecer
 *    falha de carga, nem o contrário — o gestor tomaria decisão sobre um painel quebrado
 *    achando que a rede não tem alunos.
 * 4. Nada de `v-html`. Rótulo de dimensão, título e nome de fonte vêm do banco e podem
 *    conter HTML; interpolação do Vue escapa, `v-html` não escaparia.
 * 5. `instituicoes_permitidas` nunca é enviado — quem decide escopo é o servidor.
 * 6. Duplo clique não duplica: toda ação com efeito tem flag de envio.
 */
import BarChart from '@/chart/BarChart'
import biApi from '../biApi'
import {
  estadoInicial, aplicarFiltroCruzado, removerFiltro, limpar,
  descer, subir, parametrosDeConsulta, trilha
} from '../interacao/biInteracao'

export default {
  components: { BarChart },

  data () {
    return {
      api: null,
      paineis: [],
      slug: null,
      nomePainel: '',
      dataReferencia: null,
      dataExibida: '',
      estado: estadoInicial({}),
      series: [],
      total: 0,
      aviso: null,
      dimensoesDisponiveis: {},
      recortes: {},
      carregando: false,
      erro: null,
      // guardas contra duplo clique / duplo envio
      requisicao: 0,
      exportando: false,
      compartilhando: false,
      dialogExport: false,
      dialogCompartilhar: false,
      horasLink: 72,
      linkGerado: null
    }
  },

  computed: {
    temDados () { return !this.carregando && !this.erro && this.series.length > 0 },
    vazio () { return !this.carregando && !this.erro && this.series.length === 0 },
    temFiltros () { return Object.keys(this.estado.filtros).length > 0 },
    trilha () { return trilha(this.estado) },
    resumoFiltros () {
      const f = this.estado.filtros
      return Object.keys(f).map(function (k) { return k + '=' + f[k] }).join(', ')
    },
    painelAtual () {
      const s = this.slug
      return this.paineis.filter(function (p) { return p.slug === s })[0] || null
    },
    dimensoesDoPainel () {
      return this.painelAtual ? (this.painelAtual.dimensoes || []) : []
    },
    rotuloDimensao () {
      return this.painelAtual && this.painelAtual.dimensoes && this.painelAtual.dimensoes.length
        ? 'Categoria' : 'Categoria'
    },
    podeDescer () { return this.dimensoesDoPainel.length > this.estado.nivel },
    dadosGrafico () {
      if (!this.series.length) return null
      return {
        labels: this.series.map(function (s) { return s.rotulo }),
        datasets: [{
          label: this.nomePainel,
          backgroundColor: '#409EFF',
          data: this.series.map(function (s) { return s.valor })
        }]
      }
    },
    opcoesGrafico () {
      return { responsive: true, maintainAspectRatio: false, legend: { display: false } }
    }
  },

  mounted () {
    this.api = biApi.criar({
      axios: this.$axios, base: this.base(), auth: this.auth(),
      authBlob: this.$store.getters.getHeaderAuthExcel
    })
    this.carregarPaineis()
  },

  methods: {
    base () { return this.$store.state.config.baseUrlApi },
    auth () { return this.$store.getters.getHeaderAuth },

    /**
     * Mensagem de erro compreensível. 403 do backend NÃO vira tela vazia: o usuário precisa
     * saber que foi negado, não achar que não há dados.
     */
    /**
     * Normaliza o erro que a API devolve.
     *
     * ARMADILHA REAL deste backend: negativa de permissão vem com HTTP **200** e corpo
     * `{erro: {cod: 800, text: '...'}}` — não com 403. Tratar só `status === 403` nunca
     * dispararia, e atribuir `d.erro` direto renderizaria "[object Object]" na tela.
     * O interceptor global de `main.js` já redireciona 800/801 para `/not-permission`;
     * isto cobre os demais casos e o texto exibido.
     */
    textoErro (erro) {
      if (!erro) return null
      if (typeof erro === 'string') return erro
      if (erro.text) return erro.text
      if (erro.message) return erro.message
      return 'Não foi possível concluir a operação.'
    },

    mensagemErro (e) {
      const r = e && e.response ? e.response : null
      if (!r) return 'Falha de comunicação com o servidor.'
      if (r.status === 401) return 'Sessão expirada. Entre novamente.'
      if (r.status === 403) return 'Você não tem autorização para este painel.'
      if (r.data && r.data.erro) return this.textoErro(r.data.erro)
      return 'Erro ' + r.status + ' ao consultar o servidor.'
    },

    carregarPaineis () {
      const self = this
      this.carregando = true
      this.api.listarPaineis().then(function (r) {
        self.paineis = r.data || []
        self.carregando = false
        if (self.paineis.length) {
          const daUrl = self.$route.query.painel
          const existe = self.paineis.filter(function (p) { return p.slug === daUrl })[0]
          self.slug = existe ? daUrl : self.paineis[0].slug
          self.trocarPainel()
        }
      }).catch(function (e) {
        self.carregando = false
        self.erro = self.mensagemErro(e)
      })
    },

    trocarPainel () {
      this.estado = estadoInicial({ slug: this.slug })
      this.recortes = {}
      this.linkGerado = null
      const p = this.painelAtual
      this.nomePainel = p ? p.nome : ''
      this.carregar()
    },

    /** Filtros enviados: os do estado + data. Nunca escopo institucional. */
    filtrosAtuais () {
      const f = Object.assign({}, this.estado.filtros)
      if (this.dataReferencia) f.data_referencia = this.dataReferencia
      return f
    },

    carregar () {
      if (!this.slug) return
      const self = this
      const meu = ++this.requisicao        // descarta resposta de requisição antiga

      this.carregando = true
      this.erro = null
      this.aviso = null

      this.api.dadosPainel(this.slug, this.filtrosAtuais()).then(function (r) {
        if (meu !== self.requisicao) return
        const d = r.data || {}

        if (d.erro) { self.carregando = false; self.erro = self.textoErro(d.erro); return }

        self.nomePainel = d.nome || self.nomePainel
        self.series = d.series || []
        self.total = d.total || 0
        self.aviso = d.aviso || null
        self.dataExibida = d.data_referencia || '—'
        self.dimensoesDisponiveis = d.dimensoes || {}
        self.carregando = false
        self.carregarRecortes()
      }).catch(function (e) {
        if (meu !== self.requisicao) return
        self.carregando = false
        self.erro = self.mensagemErro(e)
      })
    },

    carregarRecortes () {
      const self = this
      this.dimensoesDoPainel.forEach(function (dim) {
        self.$set(self.recortes, dim, { carregando: true, itens: [], erro: null })
        self.api.recorte(self.slug, dim, self.filtrosAtuais()).then(function (r) {
          const d = r.data || {}
          self.$set(self.recortes, dim, {
            carregando: false, itens: d.itens || [], erro: d.erro || null
          })
        }).catch(function (e) {
          self.$set(self.recortes, dim, { carregando: false, itens: [], erro: self.mensagemErro(e) })
        })
      })
    },

    // ---------------------------------------------------- interação (biInteracao)

    dimensaoPrincipal () {
      return this.dimensoesDoPainel.length ? this.dimensoesDoPainel[0] : 'categoria'
    },

    selecionada (linha) {
      const dim = this.dimensaoPrincipal()
      return this.estado.filtros[dim] === String(linha.chave)
    },

    filtrarPor (linha) {
      const widget = { id: 'principal', dimensao: this.dimensaoPrincipal() }
      this.estado = aplicarFiltroCruzado(this.estado, widget, linha.chave)
      this.carregar()
    },

    filtrarPorRecorte (dim, item) {
      this.estado = aplicarFiltroCruzado(this.estado, { id: 'recorte-' + dim, dimensao: dim }, item.chave)
      this.carregar()
    },

    descerPor (linha) {
      const dim = this.dimensoesDoPainel[this.estado.nivel] || this.dimensaoPrincipal()
      this.estado = descer(this.estado, dim, linha.chave)
      this.carregar()
    },

    subir () {
      this.estado = subir(this.estado)
      this.carregar()
    },

    removerFiltro (dim) {
      this.estado = removerFiltro(this.estado, dim)
      this.carregar()
    },

    limparTudo () {
      this.estado = limpar(this.estado)
      this.carregar()
    },

    /** Exposto para teste: o payload que iria à API para um widget. */
    payloadDoWidget (widget) {
      return parametrosDeConsulta(this.estado, widget)
    },

    // ------------------------------------------------------------------ ações

    /** BI 13 — o export leva os MESMOS filtros que a tela está exibindo. */
    exportar (formato) {
      if (this.exportando) return           // duplo clique não gera dois downloads
      const self = this
      this.exportando = true

      this.api.exportar(this.slug, formato, this.filtrosAtuais()).then(function (r) {
        const nome = self.slug + '-' + (self.dataExibida || 'painel') + '.' +
          (formato === 'png' ? 'svg' : formato)
        self.baixar(r.data, nome)
        self.exportando = false
        self.dialogExport = false
      }).catch(function (e) {
        self.exportando = false
        window.eventBus.$emit('alert', { msg: self.mensagemErro(e), type: 'error' })
      })
    },

    baixar (blob, nome) {
      const url = window.URL.createObjectURL(new Blob([blob]))
      const a = document.createElement('a')
      a.href = url
      a.setAttribute('download', nome)
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },

    /** BI 17 — link com escopo do criador, congelado no servidor. */
    compartilhar () {
      if (this.compartilhando) return       // duplo clique não gera dois links
      const self = this
      this.compartilhando = true

      this.api.compartilhar(this.slug, this.filtrosAtuais(), this.horasLink).then(function (r) {
        self.linkGerado = r.data
        self.compartilhando = false
      }).catch(function (e) {
        self.compartilhando = false
        window.eventBus.$emit('alert', { msg: self.mensagemErro(e), type: 'error' })
      })
    },

    tituloRecorte (dim) {
      const nomes = {
        serie: 'Por série', turno: 'Por turno', faixa_etaria: 'Por faixa etária',
        deficiencia: 'Por tipo de deficiência', localizacao_diferenciada: 'Em local especial',
        bairro: 'Por bairro', escolaridade: 'Por escolaridade',
        curso_superior: 'Por curso superior', tipo_pos: 'Por tipo de pós',
        ordem_preferencia: 'Por ordem de preferência', situacao: 'Por situação'
      }
      return nomes[dim] || dim
    }
  }
}
</script>

<style scoped>
.estado { padding: 30px; text-align: center; color: #909399; }
.estado-pequeno { padding: 10px; color: #909399; font-size: 12px; }
.estado-pequeno.erro { color: #F56C6C; }
.cartao { background: #f5f7fa; border-radius: 4px; padding: 14px; }
.cartao-rotulo { font-size: 12px; color: #909399; }
.cartao-valor { font-size: 30px; font-weight: 600; color: #303133; }
.cartao-nota { font-size: 11px; color: #909399; }
.grafico-wrap { height: 200px; }
.linha-selecionada { background: #ecf5ff !important; }
.rotulo-filtro { font-size: 12px; color: #909399; margin-right: 6px; }
.obs { font-size: 12px; color: #909399; }
.resumo-export { font-size: 12px; background: #f5f7fa; padding: 10px; border-radius: 4px; }
.table-sm td { padding: 4px 6px; font-size: 12px; }
</style>
